/* eslint-disable */
import React, { memo, useEffect, useState } from "react";

import "./index.scss";
import "./jquery.tagcanvas";

import AnimatedLetter from "../../AnimatedLetters";

const Skill = () => {
  const [letterClass, setLetterClass] = useState("text-animate");

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  $(document).ready(function () {
    if (
      !$("#myCanvas").tagcanvas(
        {
          textColour: "#1854b4",
          outlineThickness: 1,
          maxSpeed: 0.08,
          depth: 0.8,
          outlineColor: "transparent",
          weight: true,
          radius: "65%",
          radiulmin: 75,
          fontFamily: "Coolvetica",
          initial: [0.3, -0.3],
        },
        "tags"
      )
    ) {
      $("#myCanvasContainer");
    }
  });

  return (
   <div className="skill-container">
     <div className="skill__page">
      <div className="text__zone">
        <h1>
          <AnimatedLetter
            letterClass={letterClass}
            strArray={["M", "y", "", "S", "k", "i", "l", "l"]}
            idx={15}
          />
        </h1>
        <p>
          I am a web developer with expertise in technologies such as HTML, CSS,
          JavaScript, React, Next.js, Bootstrap, Tailwind, Redux, Redux Toolkit,
          SASS, Node.js, Express.js, MongoDB, MySQL, and PostgreSQL.
        </p>
        <p>
          I have experience in creating responsive, dynamic web applications and
          can develop solutions using various web technologies. Additionally, I
          have a basic understanding of blockchain technology.
        </p>
      </div>

      <div className="skill__charts">
        <div id="myCanvasContainer">
          <canvas width="420" height="500" id="myCanvas" className="my-canvas">
            <ul id="tags">
              <li>
                <a href="google.com" target="_blank">
                  HTML
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  CSS
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Bootstap
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  SASS
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Java Script
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Jquery
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  TypeScript
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  React
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Next Js
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Node Js
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Express Js
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  MongoDB
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Git
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Github
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  BEM
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  REST
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Ejs
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Redux
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  json
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  npm
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  MySQL
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  PostgreSQL
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Tailwind
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Redux
                </a>
              </li>
              <li>
                <a href="google.com" target="_blank">
                  Redux Toolkit
                </a>
              </li>
            </ul>
          </canvas>
        </div>
      </div>
    </div>
   </div>
  );
};

export default memo(Skill);
